import { request } from '../request';
import apiRoute from './router';

/** 获取权限组 */
export function rbacAdminGroup() {
  return request.get<ApiAccount.PermMenu>(apiRoute.rbacAdminGroup);
}

/** 获取用户信息 */
export function getAccountInfo() {
  return request.get<ApiBase.List<ApiAccount.AdminUserInfo>>(apiRoute.adminUserDetail);
}

/** 用户修改个人信息 */
export function updateAccountInfo(data: ApiAccount.AdminUserInfo) {
  return request.post<any>(apiRoute.adminUserEdit, data);
}

/** 修改密码信息 */
export function updateAccountPassword(data: ApiAccount.UpdatePasswordParams) {
  return request.post<any>(apiRoute.adminUserForget, data);
}

/** 获取用户监控 */
export function getMonitorList(query: any) {
  return request.get<any>(apiRoute.adminMonitorList, { params: query });
}

/** 获取回放视频 */
export function postReviewVideoData(data: any) {
  return request.post<any>(apiRoute.commandScreenUp, data);
}

/** 获取站点账号信息 */
export function getSiteAdminList(params: ApiBase.PageParams) {
  return request.get<ApiBase.List<ApiUser.UserListItem[]>>(apiRoute.commonAdminU, { params });
}
